module.exports = "//public.getcloudapp.com/packs/media/images/salesforce-b6d5bfe298cbe86faaebcfa972fb95c5.png";